import React from 'react';
import { Outlet } from 'react-router-dom';
import Navbar from './Navbar';
import Footer from './Footer';
import ThreeBackground from '../three/ThreeBackground';

const Layout = ({ showBackground = true }) => {
  return (
    <div className="min-h-screen bg-black text-white overflow-x-hidden font-body">
      {showBackground && <ThreeBackground />}
      <Navbar />
      <main>
        <Outlet />
      </main>
      <Footer />
    </div>
  );
};

export { Navbar, Footer };
export default Layout;
